import { useTinyPlayerStore } from '@stores/useTinyPlayerStore'

export function useTinyPlayer() {
  const isTinyPlayer = useTinyPlayerStore((state) => state.isTinyPlayer)
  const setIsTinyPlayer = useTinyPlayerStore((state) => state.setIsTinyPlayer)

  return {
    isTinyPlayer,
    setIsTinyPlayer,
  }
}
